module.exports = __webpack_public_path__ + "img/mikotomobile_char.bd6e7088.png";